module.exports = __webpack_public_path__ + "static/sport/logo.c3d967a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/logo.png
// module id = Boj1
// module chunks = 0